
import Vue from 'vue';
import Notebook from './Notebook.vue';
import { SharedNotebook } from '@/models/student-notes/shared-notebook.model';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export default Vue.extend({
  components: {
    Notebook,
  },
  computed: {
    mainLogo(): string {
      return `${process.env.BASE_URL || ''}img/main-logo.svg`;
    },
    collegeLogo(): string {
      return `${process.env.BASE_URL || ''}img/CollegeLogo.svg`;
    },
    notebookHash(): string {
      return this.$route.params.notebookHash;
    },
    isLoadingSharedNotebook(): boolean {
      return this.$store.getters.isLoadingSharedNotebook;
    },
    otherStudentSharedNotebook(): SharedNotebook {
      return this.$store.getters.getOtherStudentSharedNotebook;
    },
  },
  created() {
    this.pullSharedNotebook();
  },
  methods: {
    async pullSharedNotebook(): Promise<void> {
      await this.$store.dispatch('GET_OTHER_STUDENT_SHARED_NOTEBOOK', {
        notebookHash: this.notebookHash,
      });
      if (this.otherStudentSharedNotebook) {
        Analytics.trackEvent(EVENT_LABELS.notebookInteracted, {
          discipline_id: this.otherStudentSharedNotebook.dexDisciplineId,
          interaction_type: 'Shared Link Opened',
        });
      }
    },
  },
});
